import {
  HosDriverProfileDto,
  useGetAllHosProfilesQuery,
} from "../../../api/vehiclesApi";
import { useSignalR } from "../../../contexts/SignalRContext";

interface UseHosProfilesResult {
  profiles: HosDriverProfileDto[];
  isLoading: boolean;
  error: string | null;
}

export const useHosProfiles = (): UseHosProfilesResult => {
  const { isConnecting } = useSignalR();

  // Always use RTK Query for HOS profiles data
  // SignalR will provide real-time updates through the connection
  const {
    data: profiles = [],
    isLoading: isQueryLoading,
    error: queryError,
  } = useGetAllHosProfilesQuery();

  // Determine loading state
  const isLoading = isConnecting || isQueryLoading;

  // Determine error state
  const error = queryError ? "Failed to fetch HOS data" : null;

  return {
    profiles,
    isLoading,
    error,
  };
};
